import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import ThemeButtonMenuItem from 'assets/components/button/themes/Theme.Button.MenuItem';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import CheckInput from 'assets/components/inputs/check/CheckInput';
import { inputStyles } from 'assets/components/inputs/Input';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales } from 'assets/locales/Locale';
import DropdownButton from 'assets/templates/dropdownButton/DropdownButton';
import ThemeDropdownButtonPopup from 'assets/templates/dropdownButton/themes/Theme.DropdownButton.Popup';
import ThemeWrapperPaper from 'assets/themes/wrappers/Theme.Wrapper.Paper';
import ProductReportRecipient from 'models/enums/ProductReportRecipient';
import { useProductProvider } from '../../Product.Hooks';

const ProductReportSettings = () => {
  const { form } = useProductProvider();
  const { lang, translate } = getLocales();
  const productReportRecipientValues = Object.keys(ProductReportRecipient).map((key) => ({
    id: key,
    title: translate(key),
  }));

  const availableRecipients = productReportRecipientValues.filter(
    (it) => !form.data?.productReportRecipients?.some((rec) => rec.name === it.id)
  );

  const addReporterSettings = (data: { id: string; title: string }) => {
    const selected = productReportRecipientValues.find((it) => it.id === data.id);
    if (!selected) return;
    const newReportSetting = {
      name: selected?.id,
      reportsEnabled: false,
    } as Model.IProductReportRecipient;

    form.update({
      productReportRecipients: [...(form.data.productReportRecipients ?? []), newReportSetting],
    });
  };
  const updateReporterSettings = (data: Utils.FormData<Model.IProductReportRecipient>) => {
    form.update({
      productReportRecipients: (form.data?.productReportRecipients ?? []).map((it) =>
        it.name === data.name ? { ...it, reportsEnabled: data.reportsEnabled } : it
      ),
    });
  };

  const removeReporterSettings = (data: Utils.FormData<Model.IProductReportRecipient>) => {
    form.update({
      productReportRecipients: form.data?.productReportRecipients?.filter((it) => it.name !== data.name),
    });
  };

  return (
    <FormWrapper class={ThemeWrapperPaper}>
      <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center' }}>
        <div style={{ fontWeight: 'bold' }}> {lang.reportSettings}</div>
        <DropdownButton
          buttonBody={lang.add}
          buttonMedia={<Icon class="fas-plus" />}
          horizontalPosition="auto_fixed"
          verticalPosition="auto_fixed"
          subcomponents={ThemeDropdownButtonPopup}
          tabIndex={null}
          htmlElementProps={{ title: `${lang.add} ${lang.reportSettings}` }}
          dropdownOptions={
            <DataMap
              data={availableRecipients}
              render={({ data }) => (
                <Button
                  key={data.id}
                  render={data.title}
                  class={ThemeButtonMenuItem}
                  data={data}
                  onClick={addReporterSettings}
                  htmlElementProps={{ title: `${lang.add} ${data.title} ${lang.reportRecipient}` }}
                />
              )}
            />
          }
        />
      </div>
      <br />
      <table className={ThemeTableSimple}>
        <thead>
          <tr>
            <th>{lang.name}</th>
            <th>{lang.settings}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <DataMap
            data={form.data.productReportRecipients}
            render={({ data }) => {
              return (
                <tr>
                  <th>{data.name}</th>
                  <th>
                    <CheckInput
                      label={lang.reportsEnabled}
                      name="reportsEnabled"
                      class={inputStyles.check.radio}
                      value={data.reportsEnabled}
                      onChange={({ reportsEnabled }) =>
                        updateReporterSettings({ ...data, reportsEnabled: Boolean(reportsEnabled) })
                      }
                    />
                  </th>
                  <th>
                    <Button
                      media={<Icon class="fas-trash" />}
                      class={ThemeButtonCircle}
                      data={data}
                      onClick={removeReporterSettings}
                    />
                  </th>
                </tr>
              );
            }}
          />
        </tbody>
      </table>
    </FormWrapper>
  );
};

export default ProductReportSettings;
